import React, { memo } from 'react';
import dayjs from 'dayjs';
import weekOfYear from 'dayjs/plugin/weekOfYear';

import Button from '../helpers/Button';

dayjs.extend(weekOfYear);

const PresetDateRangeButtonsComponent = ({ onSelectPreset }) => {
  const handleClick = range => {
    switch (range) {
      case 'CW': {
        const dateFrom = dayjs()
          .startOf('week')
          .add(1, 'day');
        const dateTo = dayjs()
          .endOf('week')
          .add(1, 'day');

        onSelectPreset(dateFrom, dateTo);
        break;
      }

      case 'LW': {
        const dateFrom = dayjs()
          .startOf('week')
          .subtract(6, 'day');
        const dateTo = dayjs()
          .endOf('week')
          .subtract(6, 'day');

        onSelectPreset(dateFrom, dateTo);
        break;
      }

      case 'MTD': {
        const dateFrom = dayjs().startOf('month');
        const dateTo = dayjs();

        onSelectPreset(dateFrom, dateTo);
        break;
      }

      case 'YTD': {
        const dateFrom = dayjs().startOf('year');
        const dateTo = dayjs();

        onSelectPreset(dateFrom, dateTo);
        break;
      }

      case 'TTM': {
        const dateFrom = dayjs()
          .subtract(12, 'month')
          .startOf('month');
        const dateTo = dayjs()
          .subtract(1, 'month')
          .endOf('month');

        onSelectPreset(dateFrom, dateTo);
        break;
      }

      default:
        break;
    }
  };

  return (
    <>
      <label>Date Range</label>
      <div>
        <Button onClick={() => handleClick('CW')}>Current Week</Button>
        <Button onClick={() => handleClick('LW')}>Last Week</Button>
        <Button onClick={() => handleClick('MTD')} title="Month to Date">
          MTD
        </Button>
        <Button onClick={() => handleClick('YTD')} title="Year to Date">
          YTD
        </Button>
        <Button onClick={() => handleClick('TTM')} title="Trailing Twelve Months">
          TTM
        </Button>
      </div>
    </>
  );
};

/** Preset date range buttons component. */
export const PresetDateRangeButtons = memo(PresetDateRangeButtonsComponent);
